/* eslint-disable consistent-return */

import Questions from '@gameday/common/components/form/Pages/Questions'
/* eslint-disable no-nested-ternary */
import { get } from 'lodash'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import config from '../../../../constants/config'
import { common, files } from '../../../../constants/endpoints'
import { privateRoutes } from '../../../../constants/routes/routes'

const StyledQuestions = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
  .rich-text-link {
    color: ${props => props.formSettings.textLinkColour} !important;
  }
  .country-select__control\.country-select__control--is-focused {
    border-color: ${props => props.formSettings.textLinkColour} !important;
  }
`

const QuestionsComponent = ({
  currentRegistration,
  formProducts,
  formAddOnProducts = [],
  formTeamProducts = [],
  formSubEventProducts = [],
  memberTypes,
  questions = [],
  userId,
  form,
  clearParticipant,
  setValue,
  defaultCountry,
  hierarchyCountryCode,
  previousStep,
  next = () => {},
  previous = () => {},
  timezones,
  formSettings,
  questionPage,
  isTeamEvent,
  teamFormType,
  setTeam,
  ...rest
}) => {
  const [defaultValues, setDefaultValues] = useState({})
  const isTeamRego = isTeamEvent && teamFormType === 'Register A Team'
  const filteredQuestions = isTeamEvent
    ? isTeamRego
      ? questions.filter(q => q.isTeamQuestion)
      : questions.filter(q => !q.isteamQuestion)
    : questions

  const renderDefaultMapping = () => {
    const answered = currentRegistration?.questions || {}
    const dValues = questions.reduce((a, q) => {
      const question = q.relatedQuestion
      // eslint-disable-next-line no-param-reassign
      a[question.sfid] = answered[question.sfid]
      return a
    }, {})
    const homeAddress = questions.filter(
      q => get(q, 'relatedQuestion.isSportsTGQuestion') && get(q, 'relatedQuestion.name') === 'Home Address'
    )
    const mailingAddress = questions.filter(
      q => get(q, 'relatedQuestion.isSportsTGQuestion') && get(q, 'relatedQuestion.name') === 'Postal Address'
    )
    const homeAddressId = get(homeAddress, '[0].relatedQuestion.sfid')
    const mailingAddressId = get(mailingAddress, '[0].relatedQuestion.sfid')

    if (!answered[homeAddressId]) {
      dValues[homeAddressId] = {
        city: get(currentRegistration, 'homeAddress.city'),
        country: get(currentRegistration, 'homeAddress.country'),
        postalcode: get(currentRegistration, 'homeAddress.postalCode'),
        state: get(currentRegistration, 'homeAddress.state'),
        street: get(currentRegistration, 'homeAddress.street'),
        street2: get(currentRegistration, 'homeAddress.street2'),
      }
    }

    if (!answered[mailingAddressId]) {
      dValues[mailingAddressId] = {
        city: get(currentRegistration, 'mailingAddress.city'),
        country: get(currentRegistration, 'mailingAddress.country'),
        postalcode: get(currentRegistration, 'mailingAddress.postalCode'),
        state: get(currentRegistration, 'mailingAddress.state'),
        street: get(currentRegistration, 'mailingAddress.street'),
        street2: get(currentRegistration, 'mailingAddress.street2'),
      }
    }

    setDefaultValues(dValues)
  }

  useEffect(() => {
    renderDefaultMapping()
  }, [])

  return (
    <StyledQuestions formSettings={formSettings}>
      <Questions
        questions={filteredQuestions}
        currentRegistration={currentRegistration}
        formProducts={[...formProducts, ...formAddOnProducts, ...formTeamProducts, ...formSubEventProducts]}
        formData={{
          newProducts: currentRegistration?.newProducts,
          newSubEventProducts: currentRegistration?.newSubEventProducts,
          newAddOnProducts: currentRegistration?.newAddOnProducts,
          birthdate: currentRegistration?.birthdate,
          gender: currentRegistration?.gender,
          memberTypes: currentRegistration?.memberTypes,
          userId,
          form,
          // biome-ignore lint/complexity/useOptionalChain: TODO
          pageName: (privateRoutes(isTeamEvent).find(r => r.id === 'questions') || {}).title || 'Questions',
          objectId: currentRegistration?.relatedMemberProfileId,
          objectName: 'memberProfile',
          application: config.application,
          uploadEndpoint: `api/${files.uploadDirect}`,
          documentUploadEndpoint: `api/${files.documentUploadDirect}`,
          downloadEndpoint: `api/${files.downloadDirect}`,
          subdivisionEndpoint: `api/${common.subdivisionDirect}?country={country}`,
          googleApiKey: config.GOOGLE_API_KEY,
          timezones,
        }}
        onSubmit={values => {
          if (isTeamRego) {
            setTeam({
              teamQuestions: values,
            })
            return next()
          }
          if (values) {
            setValue({
              questions: values,
              isComplete: true,
            })
            return next()
          }
          if (values === null && (questionPage === previousStep || questionPage === previousStep + 1)) {
            return previous()
          }
          setValue({ questions: values, isComplete: true })
          next()
        }}
        defaultValue={defaultValues}
        memberTypes={memberTypes}
        disableMemberType
        defaultCountry={defaultCountry}
        hierarchyCountryCode={hierarchyCountryCode}
        next={() => {}}
        previous={previous}
        isTeamEvent={isTeamEvent}
        teamFormType={teamFormType}
        {...rest}
      />
    </StyledQuestions>
  )
}

export default QuestionsComponent
